import HttpRequest from "../http_request";
class TopupApi extends HttpRequest {
  apiGetLoadPrice() {
    return this.fetch(`/client/v1/wallet/topup-packages`);
  }
  apiGetBankLoad(){
    return this.fetch(`/client/v1/banks`)
  }
  apiGetTopUpMoney(data){
    return this.create(`/client/v2/topup-approvals`,data)
  }
}

export default TopupApi;
